import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f56c25aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left h-full flex justify-around flex-col order-1 col-span-3 md:col-span-1" }
const _hoisted_2 = { class: "text-left grey-text text-xs order-3 md:order-2 col-span-3 md:col-span-1" }
const _hoisted_3 = { class: "text-right order-2 md:order-3" }
const _hoisted_4 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "grid grid-cols-4 md:grid-cols-3 text-center shadow-lg w-4/5 mx-auto my-8 h-32 p-5 md:p-12 items-center",
    style: {"border-radius":"6px","height":"fit-content"},
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salonSelected(_ctx.salon)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.salon.title), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.salon.naslov), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.salon.postnaStevilka) + " " + _toDisplayString(_ctx.salon.mesto), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: "radio",
        name: "salon",
        checked: this.$store.state.salon === _ctx.salon
      }, null, 8, _hoisted_4)
    ])
  ]))
}